<template>
  <div>
    <div class="panel panel-stretch panel-primary">
      <div class="panel-heading">
        Klant selecteren
      </div>
      <div class="panel-body">
        <p>U heeft keuze uit een van de volgende opties om het bericht te importeren:</p>
        <ul>
          <li>selecteer een klant uit de voortgestelde lijst</li>
          <li>zoek zelf een klant</li>
          <li>maak een nieuwe klant aan gebaseerd op het bericht.</li>
        </ul>
      </div>
      <div class="panel-body">
        <a-tabs default-active-key="found_customers">
          <a-tab-pane key="found_customers" tab="Klanten">
            <table class="table table-striped" v-if="foundCustomers[0]">
              <thead>
              <tr>
                <th>Klant</th>
                <th>Adres</th>
                <th>Contact</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="customer in foundCustomers" :key="customer.id">
                <td class="compact">
                  <customer-badge-component :customer="customer"></customer-badge-component>
                  <br/>
                  <p v-if="customer.birthday">{{ customer.birthday }}</p>
                </td>
                <td>
                  <div v-if="hasAddress(customer)">
                    <p v-if="getProperty(customer) !== null">
                      {{ getProperty(customer).street }} {{ getProperty(customer).number }}{{ getProperty(customer).number_letter }} {{ getProperty(customer).number_addition }}<br>
                      {{ getProperty(customer).postal_code }} {{ getProperty(customer).city }}
                    </p>
                    <p v-else>-</p>
                  </div>
                </td>
                <td>
                  <p v-if="customer.email_address">
                    <i class="mdi mdi-at"></i> {{ customer.email_address }}
                  </p>
                  <p v-if="customer.phone">{{ customer.phone }}</p>
                  <p v-if="customer.mobile">{{ customer.mobile }}</p>
                </td>
                <td>
                  <a-button type="primary" @click="customerSelected(customer)">
                    Selecteer
                  </a-button>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-else>
              <p>Geen klanten gevonden op basis van het pakket-bericht</p>
              <p>Zoek een klant of maak een nieuwe klant aan</p>
            </div>
          </a-tab-pane>
          <a-tab-pane key="search" tab="Zoeken">
            <search-by-name-component v-on:customer-selected="customerSelected"></search-by-name-component>
          </a-tab-pane>
          <a-tab-pane key="new" tab="Nieuwe klant">
            <a-form-model :model="newCustomer" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-form-model-item label="Achternaam*">
                <a-input v-model="newCustomer.lastName"
                         @change="resetValidationFeedback('newCustomerValidationFeedback', 'lastName')"/>
                <div :v-if="newCustomerValidationFeedback.lastName">{{ newCustomerValidationFeedback.lastName }}</div>
              </a-form-model-item>
              <a-form-model-item label="Voornaam*">
                <a-tooltip placement="topLeft" title="Voorletters of voornaam is verplicht.">
                  <i class="mdi mdi-alert-circle" style="font-size: 2rem;"></i>
                </a-tooltip>
                <a-input v-model="newCustomer.firstName"
                         @change="resetValidationFeedback('newCustomerValidationFeedback', 'firstName')"/>
              </a-form-model-item>
              <a-form-model-item label="Voorletters*">
                <a-input v-model="newCustomer.initials"
                         @change="resetValidationFeedback('newCustomerValidationFeedback', 'firstName')"/>
                <div :v-if="newCustomerValidationFeedback.firstName">{{ newCustomerValidationFeedback.firstName }}</div>
              </a-form-model-item>
              <a-form-model-item label="Tussenvoegsel">
                <a-input v-model="newCustomer.suffix"/>
              </a-form-model-item>
              <a-form-model-item label="E-mailadres">
                <a-input v-model="newCustomer.emailAddress"
                         @change="resetValidationFeedback('newCustomerValidationFeedback', 'emailAddress')"/>
                <div :v-if="newCustomerValidationFeedback.emailAddress">{{
                    newCustomerValidationFeedback.emailAddress
                  }}
                </div>
              </a-form-model-item>
              <a-form-model-item label="Geboortedatum">
                <a-date-picker
                    v-model="newCustomer.dateOfBirth"
                    :format="dateDisplay"
                    :valueFormat="dateFormat"
                    type="date"
                    placeholder="Kies een datum"
                    style="width: 100%;"
                />
              </a-form-model-item>
              <a-form-model-item label="Geslacht">
                <a-radio-group button-style="solid" default-value="" v-model="newCustomer.sex">
                  <a-radio value="">
                    Onbekend
                  </a-radio>
                  <a-radio value="1">
                    Man
                  </a-radio>
                  <a-radio value="0">
                    Vrouw
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                <a-button type="primary" @click="customerSelected('newCustomer')">
                  Selecteer
                </a-button>
              </a-form-model-item>
            </a-form-model>
          </a-tab-pane>
          <a-tab-pane key="newBusiness" tab="Zakelijke klant">
            <a-form-model :model="newBusiness" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-form-model-item label="Bedrijfsnaam*">
                <a-input v-model="newBusiness.companyName"
                         @change="resetValidationFeedback('newBusinessValidationFeedback', 'companyName')"/>
                <div :v-if="newBusinessValidationFeedback.companyName">
                  {{ newBusinessValidationFeedback.companyName }}
                </div>
              </a-form-model-item>
              <a-form-model-item label="E-mailadres">
                <a-input v-model="newBusiness.emailAddress"
                         @change="resetValidationFeedback('newBusinessValidationFeedback', 'emailAddress')"/>
                <div :v-if="newBusinessValidationFeedback.emailAddress">
                  {{ newBusinessValidationFeedback.emailAddress }}
                </div>

              </a-form-model-item>
              <a-form-model-item label="Datum van oprichting">
                <a-date-picker
                    v-model="newBusiness.startDate"
                    :format="dateDisplay"
                    :valueFormat="dateFormat"
                    type="date"
                    placeholder="Kies een datum"
                    style="width: 100%;"
                />
              </a-form-model-item>
              <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                <a-button type="primary" @click="customerSelected('newBusiness')">
                  Selecteer
                </a-button>
              </a-form-model-item>
            </a-form-model>
          </a-tab-pane>
        </a-tabs>
        <div class="col-sm-10">
        </div>
        <div class="col-sm-10">
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import SearchByNameComponent from "../../customer/components/SearchByNameComponent";
import {mapGetters} from 'vuex'
import store from '../../../store';
import siviModule from '../store'
import CustomerBadgeComponent from "../../customer/components/BadgeComponent";

export default {
  name: "selectCustomerComponent",
  props: {},
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      newCustomer: {
        firstName: '',
        lastName: '',
        suffix: '',
        emailAddress: '',
        initials: '',
        sex: undefined,
        dateOfBirth: '',
        type: 1
      },
      newCustomerValidationFeedback: {},
      newBusiness: {
        companyName: '',
        emailAddress: '',
        startDate: '',
        type: 9
      },
      newBusinessValidationFeedback: {
        companyName: '',
        emailAddress: '',
        startDate: '',
      },
      dateFormat: 'YYYY-M-D',
      dateDisplay: 'D-M-YYYY',
    }
  },
  created() {
    if (!store.hasModule('sivi')) {
      store.registerModule('sivi', siviModule)
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters('sivi', [
      'currentPackages',
      'selectedCustomerId',
      'foundCustomers'
    ]),
  },
  methods: {
    hasAddress(customer) {
      return (customer !== null
          && typeof customer !== 'undefined'
          && customer.current_visit_customer_property !== null
          && typeof customer.current_visit_customer_property !== 'undefined'
          && customer.current_visit_customer_property.data.property !== null
          && typeof customer.current_visit_customer_property.data.property !== 'undefined'
      );
    },
    getProperty(customer) {
      if (!this.hasAddress(customer)) return null;

      const property = customer.current_visit_customer_property.data.property.data;

      if (property !== null && typeof property !== 'undefined' && Object.keys(property).length !== 0) {
        return {
          street: property.street,
          number: property.number,
          number_letter: property.number_letter ? property.number_letter : '',
          number_addition: property.number_addition ? property.number_addition : '',
          postal_code: property.postal_code.toUpperCase(),
          city: property.city ? property.city.charAt(0).toUpperCase() + property.city.slice(1) : '',
        };
      }

      return null;
    },
    customerSelected(event) {
      let validData = true
      if (event === 'newCustomer') {
        validData = this.validateNewCustomer()
        if (validData) {
          store.dispatch('sivi/selectCustomer', {
            selectedCustomerId: 'newCustomer',
            selectedCustomer: false,
            newCustomerData: this.newCustomer
          })
        }
      } else if (event === 'newBusiness') {
        validData = this.validateNewBusiness()
        if (validData) {
          store.dispatch('sivi/selectCustomer', {
            selectedCustomerId: 'newCustomer',
            selectedCustomer: false,
            newCustomerData: this.newBusiness
          })
        }
      } else {
        store.dispatch('sivi/selectCustomer', {
          selectedCustomerId: event.id,
          selectedCustomer: event,
          newCustomerData: {}
        })
      }
      if (validData) {
        this.newCustomer = {
          firstName: '',
          lastName: '',
          suffix: '',
          emailAddress: '',
          initials: '',
          sex: undefined,
          dateOfBirth: '',
          type: 1
        };
        this.newBusiness = {
          companyName: '',
          emailAddress: '',
          startDate: '',
          type: 9
        };
        if (this.selectedCustomerId === 'newCustomer' || this.selectedCustomerId === false) {
          store.dispatch('sivi/setNewCustomerPolicyInformation', this.selectedCustomerId)
        } else {
          store.dispatch('sivi/loadCustomerPolicyInformation', this.selectedCustomerId)
        }
      }
      this.$emit('customer-is-selected');
    },
    validateNewCustomer() {
      let valid = true;
      if (this.newCustomer.lastName.length < 2) {
        valid = false;
        this.newCustomerValidationFeedback.lastName = "De achternaam moet minimaal 2 letters lang zijn"
      }
      if ((this.newCustomer.firstName === '') && (this.newCustomer.initials === '')) {
        valid = false;
        this.newCustomerValidationFeedback.firstName = "Voorletters of voornaam is verplicht."
      }
      if ((this.newCustomer.emailAddress !== '') && !this.validateEmail(this.newCustomer.emailAddress)) {
        valid = false;
        this.newCustomerValidationFeedback.emailAddress = "Dit is geen valide emailadres"
      }
      return valid;
    },
    validateNewBusiness() {
      let valid = true;
      if (this.newBusiness.companyName.length < 2) {
        valid = false;
        this.newBusinessValidationFeedback.companyName = "De bedrijfsnaam moet minimaal 2 letters lang zijn"
      }
      if ((this.newBusiness.emailAddress !== '') && !this.validateEmail(this.newBusiness.emailAddress)) {
        valid = false;
        this.newBusinessValidationFeedback.emailAddress = "Dit is geen valide emailadres"
      }
      return valid;
    },
    resetValidationFeedback(type, attribute) {
      this[type][attribute] = undefined
    },
    validateEmail(email) {
      const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    }
  },
  components: {CustomerBadgeComponent, SearchByNameComponent},
}
</script>

<style scoped>

table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>